var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"#666","font-size":"14px"}},[_c('b',[_vm._v(_vm._s(_vm.msg))]),_c('button',{on:{"click":_vm.ck}},[_vm._v("aaaa")])])}
var staticRenderFns = []

export { render, staticRenderFns }